import React from 'react';
import { fromUnixTime } from 'date-fns';
import { useTimer } from '@hooks/useTimer';

export const useIsSaleInMoreThanADay = ({
  timeStamp,
  onExpire,
}: {
  timeStamp: number;
  onExpire?: () => void;
}) => {
  const startTimeStamp = React.useMemo(() => fromUnixTime(timeStamp).getTime(), [timeStamp]);
  const { days } = useTimer({
    expiryTimestamp: startTimeStamp,
    onExpire,
  });

  return days > 0;
};
